import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MainMenuLevel2ViewModel } from '@models/api.models';
import { LinkComponent } from '@shared/routing/link/link.component';
import { NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'app-main-menu-group',
    templateUrl: './main-menu-group.component.html',
    styleUrls: ['./main-menu-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, LinkComponent, NgFor]
})
export class MainMenuGroupComponent {
    @Input()
    public readonly group: MainMenuLevel2ViewModel;
}
